import { ClinicTaskListingModel, IClinicTaskListingModel, IOrderByParams } from "@common/models";
import { SearchService } from "@common/services/searchService";
import { StandardSearchStore } from "@common/stores";
import { isUndefined } from "lodash";
import { DateTime } from "luxon";
import { makeObservable } from "mobx";

export interface IClinicTaskUserFilterable {
	taskTypeId?: number;
	creatorUserId?: number;
	assignedUserId?: number;
	assignedRoleId?: number;
	dateCreated?: DateTime;
	dateDue?: DateTime;
	dateResolved?: DateTime;
	isUrgent?: boolean;
	startDate?: string;
	endDate?: string;
	resolvedByUserId?: number;
	resolvedBy?: string;
}
export interface IClinicTaskFilter extends IClinicTaskUserFilterable {
	hospitalId?: number;
	openTasks?: boolean;
	currentUserId?: number;
}

export const defaultClinicTaskSearchFilter: IClinicTaskFilter = {};

const defaultClinicTaskSortOrder = (openTasks?: boolean): IOrderByParams[] => (isUndefined(openTasks) || openTasks ? [{ field: "datecreated", dir: "desc" }] : [{ field: "closeddate", dir: "desc" }]);

interface ClinicTaskSearchStoreArgs {
	hospitalId: number;
	openTasks?: boolean;
	currentUserId?: number;
	top?: number;
	explicitLoad?: boolean;
	startDate?: string;
	endDate?: string;
}
export class ClinicTaskSearchStore extends StandardSearchStore<IClinicTaskFilter, IClinicTaskListingModel, ClinicTaskListingModel> {
	constructor({ hospitalId, openTasks, currentUserId, top = 10, explicitLoad = true, endDate, startDate }: ClinicTaskSearchStoreArgs) {
		super(
			{				
				endpointUrl: explicitLoad ? SearchService.SearchEndPoints.tasks : SearchService.SearchEndPoints.tasksCount,
				defaultSearchParams: {
					orderby: explicitLoad ? defaultClinicTaskSortOrder(openTasks) : [],
					top: top,
				},
				defaultSearchFilter: {
					...defaultClinicTaskSearchFilter,
					hospitalId,
					openTasks,
					currentUserId,
					startDate,
					endDate,
				},
			},
			result => new ClinicTaskListingModel(result)
		);
		makeObservable(this, undefined);
	}
}
